import React from 'react';
import { reviewNotes } from '../../utils/review';
import styles from './styles.module.css';
import { divide } from 'lodash';
import Stars from '../Stars';

type NotesSummaryProps = {
  notes: Record<string, number>;
}

const NotesSummary: React.FC<NotesSummaryProps> = (props) => {
  const { notes } = props;

  return (
    <div className={styles.wrapper}>
      {reviewNotes.filter((note) => notes[note.name]).map((note) => (
        <div key={note.name} className="col-span-1">
          <span className={styles.title}>{note.label}</span>
          <div>
            <Stars
              value={Math.round(divide(notes[note.name], 2))}
              max={5}
            />
          </div>
        </div>
      ))}
    </div>
  );
}

export default NotesSummary;